import React, { useState, useRef, useEffect } from "react";
import "./SelectionSummary.scss";
import CheckboxGroup from "../../components/form/inputs/CheckboxGroup";

// Helper to detect mobile view
const useIsMobile = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	React.useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 768);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return isMobile;
};

const SelectionSummary = ({
	selections,
	showCount = true,
	showReimbursement = true,
	showAgencyPrice = false,
	handleSelectionChange,
}) => {
	const [isExpanded, setIsExpanded] = useState(false); // Default to collapsed
	const [isReimbursementExpanded, setIsReimbursementExpanded] =
		useState(true); // Add this new state
	const isMobile = useIsMobile();
	const selectionSummaryRef = useRef(null); // Ref for the selection summary

	// Hide on scroll or click outside
	useEffect(() => {
		// const handleClickOutside = (event) => {
		// 	// Ignore clicks within the reimbursement section
		// 	const isReimbursementClick = event.target.closest('#id_32');
		// 	if (
		// 		selectionSummaryRef.current &&
		// 		!selectionSummaryRef.current.contains(event.target) &&
		// 		!isReimbursementClick
		// 	) {
		// 		setIsExpanded(false);
		// 	}
		// };

		// const handleScroll = () => {
		// 	if (isMobile) {
		// 		setIsExpanded(false);
		// 	}
		// };

		// // Add event listeners
		// document.addEventListener("click", handleClickOutside);
		// window.addEventListener("scroll", handleScroll);

		// // Cleanup event listeners on component unmount
		// return () => {
		// 	document.removeEventListener("click", handleClickOutside);
		// 	window.removeEventListener("scroll", handleScroll);
		// };
	}, [isMobile]);

	const validSelections = Object.values(selections).filter(
		(value) => value !== ""
	);
	const hasSelections = validSelections.length > 0;
	const selectedCount = validSelections.length;

	// Expand the summary when a selection is made
	useEffect(() => {
		if (hasSelections) {
			setIsExpanded(true);
		}
	}, [hasSelections]);

	const displayMap = {
		"Constellation": (
			<div className="size-price-container">
				<span className="size">Constellation</span>
				{showAgencyPrice && <span className="price">$0</span>}
			</div>
		),
		"PureCars": (
			<div className="size-price-container">
				<span className="size">PureCars</span>
			</div>
		),
		"Premium: $4,000/month": (
			<div className="size-price-container">
				<span className="size">Premium</span>{" "}
				<span className="price">$4,000/Month</span>
			</div>
		),
		"Executive: $7,500/month": (
			<div className="size-price-container">
				<span className="size">Executive</span>{" "}
				<span className="price">$7,500/Month</span>
			</div>
		),
		"50%": (
			<div className="size-price-container">
				<span className="size">$500 a month</span>
			</div>
		),
		"75%": (
			<div className="size-price-container">
				<span className="size">$750 a month</span>
			</div>
		),
    "Video Production: $0/month": (
			<div className="size-price-container">
				<span className="size">Video Production</span>{" "}
				<span className="price">$0/Month</span>
			</div>
		),
	};

	const priceMap = {
		"Premium: $4,000/month": 4000,
		"Executive: $7,500/month": 7500,
	};

	return (
    <div class="selection-summary">
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        className={`selection-summary-header-wrapper ${
          isMobile ? (isExpanded ? "expanded" : "collapsed") : ""
        }`}
        ref={selectionSummaryRef}
      >
        <div className="selection-summary-header">
          <h3 className="selection-summary-title">
            YOUR ENROLLMENT {showCount && `(${selectedCount})`}
          </h3>
          {isMobile && (
            <button className="toggle-button">
              <span className={`arrow ${isExpanded ? "" : "expanded"}`}></span>
            </button>
          )}
        </div>
      </div>
      {(!isMobile || isExpanded) && (
        <div className="selection-summary-content">
          {!hasSelections ? (
            <div className="no-selections-message">
              Select your agency and package to start reviewing
            </div>
          ) : (
            <>
              <div className="selection-summary-items">
                {selections.agency && (
                    <div className="selection-item">
                      <p className="selection-item-title">Agency</p>
                      <div>
                        {displayMap[selections.agency] ||
                          selections.agency}
                      </div>
                    </div>
                  )}
                {selections.package && (
                    <div className="selection-item">
                      <p className="selection-item-title">Package</p>
                      <div>
                        {displayMap[selections.package] ||
                          selections.package}
                      </div>
                    </div>
                  )}
              </div>
              {showReimbursement && (
                <div
                  className="reimbursement-section-wrapper"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="reimbursement-header">
                    <p className="reimbursement-title">
                      Simulated Co-op Reimbursement
                    </p>
                    {!isMobile && (
                      <button
                        className="reimbursement-toggle"
                        onClick={() =>
                          setIsReimbursementExpanded(!isReimbursementExpanded)
                        }
                      >
                        <span
                          className={`arrow ${
                            isReimbursementExpanded ? "expanded" : ""
                          }`}
                        ></span>
                      </button>
                    )}
                  </div>
                  {(isMobile || isReimbursementExpanded) && (
                    <div className="reimbursement-content">
                      <div className="reimbursement-section">
                        <div className="reimbursement-section-question">
                          <CheckboxGroup
                            id="id_32"
                            name="reimbursement"
                            selectedValue={selections.reimbursement}
                            onChange={handleSelectionChange}
                            options={[
                              {
                                value: "50%",
                                label: "50%",
                              },
                              {
                                value: "75%",
                                label: "75%",
                              },
                            ]}
                          />
                        </div>
                        <div className="reimbursement-section-value">
                          {selections.reimbursement && (
                            <div className="selection-item">
                              <div className="reimbursement-amount-value">
                                {"-$" +
                                  (
                                    Object.entries(selections)
                                      .filter(
                                        ([key, value]) =>
                                          value !== "" &&
                                          key !== "reimbursement" &&
                                          key !== "agency"
                                      )
                                      .reduce(
                                        (total, [_, value]) =>
                                          total + (priceMap[value] || 0),
                                        0
                                      ) *
                                    (selections.reimbursement === "50%"
                                      ? 0.5
                                      : 0.75)
                                  ).toLocaleString()}{" "}
                                /Month
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <p className="reimbursement-section-note">
                        *Actual co-op reimbursement dependent on available
                        funds. Dealers are responsible for co-op pacing
                        throughout the year. <br /> <br /> Reimbursement amounts are set for 2026 based on
                        selections made by dealers in December.
                      </p>
                    
                      <div className="selection-total-wrapper">
                        <div className="selection-total">
                          <div className="total-title">
                            Estimated Final Cost
                          </div>
                          <div className="total-value">
                            $
                            {(
                              Object.entries(selections)
                                .filter(
                                  ([key, value]) =>
                                    value !== "" &&
                                    value !==
                                      "I do not wish to enroll in this program" &&
                                    key !== "reimbursement"
                                )
                                .reduce(
                                  (total, [_, value]) =>
                                    total + (priceMap[value] || 0),
                                  0
                                ) *
                              (selections.reimbursement === "50%"
                                ? 0.5
                                : selections.reimbursement === "75%"
                                ? 0.25
                                : 1)
                            ).toLocaleString()}
                            /Month
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="selection-total-wrapper">
                <div className="selection-total">
                  <div className="dealer-total-title">Total Cost</div>
                  <div>
                    $
                    {Object.entries(selections)
                      .filter(
                        ([key, value]) =>
                          value !== "" &&
                          key !== "reimbursement" &&
                          key !== "agency"
                      )
                      .reduce(
                        (total, [_, value]) => total + (priceMap[value] || 0),
                        0
                      )
                      .toLocaleString()}
                    /Month
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectionSummary;
